// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1le18","col":"CardReaderDesc_col___6fRf","label":"CardReaderDesc_label__3VhWT"};